document.addEventListener('alpine:init', () => {
  Alpine.data('CartItems', () => ({
    itemsRoot: null,
    loading: null,
    init() {
      this.itemsRoot = this.$root;

      window.addEventListener(
        'baseline:cart:afteradditem',
        this.onCartQuantityChange.bind(this)
      );

      window.addEventListener(
        'baseline:cart:cartqtychange',
        this.onCartQuantityChange.bind(this)
      );

      // The "Monk Free Gift with Purchase" app mutates the cart with its own
      // AJAX calls after ours (adding/removing the gift line item) and only
      // broadcasts its own event names (mr:ajaxCartUpdated, mr:cartTotalUpdate)
      // on document.documentElement — our totals/progress bar never hear about
      // it, so they can go stale right after Monk finishes reconciling the
      // gift. Debounced because Monk fires several of these per mutation.
      let externalRefreshTimer = null;
      const scheduleExternalRefresh = () => {
        clearTimeout(externalRefreshTimer);
        externalRefreshTimer = setTimeout(
          () => this.refreshFromServer(),
          400
        );
      };
      ['mr:ajaxCartUpdated', 'mr:cartTotalUpdate'].forEach((eventName) => {
        document.documentElement.addEventListener(
          eventName,
          scheduleExternalRefresh
        );
      });
    },
    async refreshFromServer() {
      const response = await fetch(
        `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
      );
      const sections = await response.json();

      // Re-dispatch through the normal channel so every listener (items,
      // footer, sticky checkout button, top free-shipping bar) re-syncs the
      // same way it would for a mutation we triggered ourselves.
      document.body.dispatchEvent(
        new CustomEvent('baseline:cart:cartqtychange', {
          bubbles: true,
          detail: { response: { sections } },
        })
      );
    },
    onCartQuantityChange(e) {
      Alpine.morph(
        this.itemsRoot,
        querySelectorInHTMLString(
          '[data-cart-items]',
          e.detail.response.sections['cart-items']
        ).outerHTML
      );

      this.$nextTick(() => {
        this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
          /**
           * Sometimes the quantity property can drift from
           * the line item input’s value due to manipulations from
           * discounts, etc.
           *
           * This treats the input’s value (from the fetch response)
           * as the source of truth and reconciles the quantity property.
           *
           */

          inputEl.value = inputEl.getAttribute('value');
          inputEl.dispatchEvent(new Event('input'));
        });
      });

      this.updateLiveRegion(
        parseDOMFromString(e.detail.response.sections['cart-live-region'])
          .firstElementChild.textContent
      );

      if (e.detail.originalTarget) {
        this.$nextTick(() => {
          if (!this.itemsRoot.contains(e.detail.originalTarget)) {
            let focusRoot;

            if (this.itemsRoot.closest('[role="dialog"]')) {
              focusRoot = this.itemsRoot.closest('[role="dialog"]').parentNode;
            } else {
              focusRoot = this.itemsRoot;
            }

            this.$focus.within(focusRoot).first();
          }
        });
      }
    },
    updateLiveRegion(liveRegionText) {
      if (!liveRegionText) return;

      const cartStatus = document.getElementById('cart-live-region-text');

      cartStatus.textContent = liveRegionText;

      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    },
  }));

  Alpine.data('CartItem', (key) => ({
    quantity: null,
    previousQuantity: null,
    key,
    locked: false,
    errorMessage: null,
    async itemQuantityChange() {
      if (this.locked || this.loading) return;

      if (this.$refs.quantityInput.hasAttribute('data-last-value')) {
        if (
          this.quantity === Number(this.$refs.quantityInput.dataset.lastValue)
        ) {
          return;
        }
      }

      this.locked = true;
      this.loading = true;

      window.__cartMutationSeq = (window.__cartMutationSeq || 0) + 1;
      const mySeq = window.__cartMutationSeq;

      const request = {
        ...fetchConfigDefaults('application/javascript'),
        body: JSON.stringify({
          id: this.key,
          quantity: this.quantity,
          sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
          sections_url: window.location.pathname,
        }),
      };

      try {
        const response = await fetch(theme.routes.cart_change_url, request);
        const data = await response.json();

        if (mySeq !== window.__cartMutationSeq) {
          // A newer cart mutation (another item changed, or a product was
          // added) has started since this request began. Its response will
          // reflect the current cart, so applying this older one now would
          // revert totals/progress bars back to stale data. Skip it.
          return;
        }

        this.cartNotifyNum = document.querySelectorAll('.cart-qty__header div, .cart-qty__header');
        this.cartNotifyHead = document.querySelectorAll('.icon-cart__notification, .cart-icon--main');
        let item_count = parseInt(data.item_count);
        if (item_count === 0 || item_count === '0') {
          this.cartNotifyHead?.forEach(head => {
            // console.log(head, "HEAD");
            if (head.classList.contains('icon-cart__icon--active')) {
              head.classList.remove('icon-cart__icon--active');
            }
          });
        } else {

          if (this.cartNotifyNum) {
            this.cartNotifyNum.forEach(el => {
              el.textContent = item_count;
            });
            // this.cartNotifyNum.textContent = item_count;
          }
        }

        if (data.status === 422) {
          this.errorMessage = data.message;
          this.quantity = this.previousQuantity;
        } else {
          this.errorMessage = null;

          document.body.dispatchEvent(
            new CustomEvent('baseline:cart:cartqtychange', {
              bubbles: true,
              detail: { response: data, originalTarget: this.$root },
            })
          );
        }
      } catch (e) {
        console.error(e);
        document.getElementById('cart-errors').textContent =
          theme.strings.cartError;
      } finally {
        this.locked = false;
        this.loading = false;
      }
    },
    removeItem() {
      const visibleQtyControl = Array.from(
        this.$root.querySelectorAll('[x-data="CartItemQuantity"]')
      ).filter((el) => el.offsetParent)[0];

      visibleQtyControl.dispatchEvent(new CustomEvent('remove'));
      // console.log(visibleQtyControl);
    },
  }));

  Alpine.data('CartItemQuantity', () => ({
    init() {
      this.$root.addEventListener('remove', () => {
        this.remove();
      });
    },
    remove() {
      this.adjustQuantity(() => {
        this.$refs.quantityInput.value = 0;
      });
    },
    ...coreQuantity,
  }));
});
